import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Layout from "@/components/Layout";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const queryNext = new URLSearchParams(loc.search).get("next");
  const next = queryNext || loc.state?.next || "/account";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      nav(next);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Sign-in failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <section className="bg-[#050505] min-h-[80vh] py-24">
        <div className="max-w-[520px] mx-auto px-6 lg:px-10">
          <div className="font-ui text-[11px] tracking-[0.32em] text-[#C9A055] mb-3">Sign In</div>
          <h1 className="font-display text-5xl text-[#F4F1EA] mb-2">WELCOME BACK.</h1>
          <p className="font-script text-[#C9A055] text-2xl mb-8">Your truths are waiting.</p>

          <form onSubmit={submit} className="space-y-4" data-testid="login-form">
            <input data-testid="login-email" required type="email" placeholder="Email" value={email} onChange={e=>setEmail(e.target.value)} className="stc-input"/>
            <input data-testid="login-password" required type="password" placeholder="Password" value={password} onChange={e=>setPassword(e.target.value)} className="stc-input"/>
            <div className="text-right">
              <Link to="/forgot-password" data-testid="forgot-link" className="font-ui text-[10px] tracking-[0.22em] text-[#C9A055] hover:text-[#E0BC72]">
                Forgot password?
              </Link>
            </div>
            <button data-testid="login-submit" disabled={loading} className="btn-gold w-full">{loading ? "Signing in…" : "Sign In"}</button>
          </form>
          <div className="mt-6 font-ui-tight text-sm text-[#B5B0A7]">
            New here? <Link to="/register" className="text-[#C9A055] hover:text-[#E0BC72]">Create an account</Link>
          </div>
        </div>
      </section>
    </Layout>
  );
}
